"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddScript = exports.default = exports.NO_SOURCE_ERROR = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// libraries

// constants
var NO_SOURCE_ERROR = "Attempted to add a script tag to the page," + "but no 'src' property was supplied.";
exports.NO_SOURCE_ERROR = NO_SOURCE_ERROR;
var useAddScript = function useAddScript(scriptObject) {
  var onLoad = scriptObject.onLoad || function () {};
  React.useEffect(function () {
    // check if a 'src' attribute was provided, if not throw and return
    if (!scriptObject.src) {
      console.error(NO_SOURCE_ERROR);
      return;
    }

    // check is script already loaded, if so, return
    var pageScripts = document.getElementsByTagName("script");
    for (var i = 0; i < pageScripts.length; i++) {
      if (pageScripts[i].src === scriptObject.src) return;
    }
    var scriptElement = document.createElement("script");

    // apply given attributes, or defaults
    scriptElement.src = scriptObject.src;
    scriptElement.type = scriptObject.type ? scriptObject.type : "text/javascript";
    if (scriptObject.async) scriptElement.async = scriptObject.async;
    if (scriptObject.defer) scriptElement.defer = scriptObject.defer;
    if (scriptObject.charset) scriptElement.charset = scriptObject.charset;

    // add onLoad event listener to the script                
    scriptElement.addEventListener("load", function () {
      onLoad();
    });

    // append the new script to the page
    document.body.appendChild(scriptElement);

    // return a clean-up function to remove listener on UnMount
    return function () {
      scriptElement.removeEventListener("load", function () {
        onLoad();
      });
    };
  }, []);
};
exports.useAddScript = useAddScript;
var _default = useAddScript;
exports.default = _default;